module.exports = __webpack_public_path__ + "img/danwei_zc_icon@2x.4209a337.png";